// hooks/useGoogleMaps.js
import { useEffect, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";

export default function useGoogleMaps(apiKey) {
    const [google, setGoogle] = useState(null);

    useEffect(() => {
        const loader = new Loader({
            apiKey,
            version: "weekly",   // or a fixed version like "beta"
            libraries: ["marker"],
        });

        loader.load().then(() => {
            setGoogle(window.google);
        });
    }, [apiKey]);

    return google;           // null until loaded
}
